import * as React from 'react';
import { ValuesOf } from '../utils/typeUtils';
import { SIZE, SKIN } from './VerticalTabs.constants';

export type VerticalTabsProps<TabId extends string | number = number> = {
  /** Child nodes of this component must be of type <code><VerticalTabs.TabsGroup></code> or <code><VerticalTabs.Footer></code>*/
  children?: React.ReactNode;
  /** Text Size (tiny, small, medium) */
  size?: VerticalTabsSize;
  /** Current selected tab id */
  activeTabId?: TabId;
  /** Callback function called on tab selection change with the following parameters<code>(id)</code> */
  onChange?: (id: TabId) => void;
  /** Data attribute for testing purposes */
  dataHook?: string;
  /** Specifies the skin of a TabItem. */
  skin?: ValuesOf<typeof SKIN>;
};

export type VerticalTabsSize = ValuesOf<typeof SIZE>;

export type VerticalTabsFooterProps = {
  children?: React.ReactNode;
};

export type TabsGroupProps = {
  children?: React.ReactNode;
  title?: string;
};
